module.exports = __webpack_public_path__ + "img/yoga_demo.6df7f0de.jpg";